import './VariableStep.scss';

export { default } from './VariableStep';
